export default function () {
    $('.schema-faq-section').on('click', function () {
        $(this).toggleClass('opened');
        $(this).find('.schema-faq-answer').slideToggle(500, 'swing');
    });
}
